import React from 'react';
import { TextButton } from '@oneaudi/unified-web-components';
const GetButton = ({ buttonInfo, variant, trackButtonClick, isMobileScreenSize, isLoading, }) => {
    const { label, url, target, type } = buttonInfo;
    return (React.createElement(TextButton, { variant: variant, href: url, target: target, "data-testid": `${type}-button-variant-${variant}`, "data-tracking-exclude": true, isFullWidth: isMobileScreenSize, isLoading: isLoading, onClick: () => {
            trackButtonClick(buttonInfo, variant, buttonInfo.trackingCode);
        } }, label));
};
export default GetButton;
